// Youtube video controller
theme.Youtube_videos = new function () {
    // Add these tiny css rules http://www.funkertech.com/windows/w6/sass/bootstrap/_responsive-embed.scss
    // ==> ".embed-responsive" to parent with: ".embed-responsive-16by9" or ".embed-responsive-4by3"
    // ==> ".embed-responsive-item" to video placeholder

    // Should also add custom CSS rules to show/hide cover images or any other elements based on the status data selector
    // ==> ex, .embed-responsive[data-activity-status="playing"], .embed-responsive[data-activity-status="ended"]

    var self = this;

    self.initiated = false;
    self.players = [];
    self.array_videos = [];
    self.lastVideoPlay = null;

    self.selectors = {
        VIDEO : "[data-youtube-id]",
        PARENT : ".embed-responsive",
        TRIGGER : ".embed-video-trigger"
    };

    self.data_selectors = {
        INITIATED : 'initiated',
        YOUTUEB_ID : 'youtubeId',
        STATUS : 'activity-status'
    };

    // TODO: revoir.
    $('[data-video-close]').on('click', function() {
        try {
            self.players[self.lastVideoPlay].player.pauseVideo();
        } catch(err){
            console.log(err)
        }
    })

    function youtube_videos () {
        // Only init if there are youtube placeholders on the page
        if (!$(self.selectors.VIDEO).length) return;

        // Attach cover click events
        $('body').on("click", self.selectors.TRIGGER, function (e) {
            e.preventDefault();
            var current_id = $(this).attr("class").split(' ')[0];
            self.play_video($(this).closest(self.selectors.PARENT), current_id);
        })

        // only load script if the widget was not initiated beforehand.
        if (!self.initiated) {
            // add youtube script
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // wait for youtube activation
            window.onYouTubeIframeAPIReady = self.activation_listner;
        }
    }

    self.play_video = function ($parent, youtubeId) {
        try {

            self.array_videos.some(function(video, index) {
              if (video[1] != youtubeId) return false;

              var videoDomId = $parent.find(self.selectors.VIDEO).attr("id");
              if (self.players[videoDomId] != undefined) {
                  if (videoDomId != self.lastVideoPlay && self.lastVideoPlay != null) { // We can run only one video at a time, if another is being played => pause it.
                      self.players[self.lastVideoPlay].player.pauseVideo();
                  }
                  self.players[videoDomId].player.playVideo();
                  self.lastVideoPlay = videoDomId;
              } else {
                  self.initPlayer(video[0], video[1], video[2], video[3], index);
                  var videoDomId = $parent.find(self.selectors.VIDEO).attr("id");
              }

              return true;
            });
        } catch (e) {
            console.log("failed to play video");
            console.log(e.message);
        }
    }

    self.activation_listner = function () {
        self.initiated = true;
        self.iterate();
    }

    self.iterate = function () {
        $(self.selectors.VIDEO).each(function () {
            var videoHolder = $(this);
            if (videoHolder.data(self.data_selectors.INITIATED)) return;

            var youtubeId = videoHolder.data(self.data_selectors.YOUTUEB_ID);

            var domId = videoHolder.prop('id');
            if (!domId) {
              var random = Math.floor(Math.random() * 60000) + 1000;
              domId = 'youtube-placeholder-' + youtubeId + '-' + random;
              videoHolder.attr('id', domId);
            }

            var showControles = videoHolder.data('controls') || 0;
            var autoplay = videoHolder.data('autoplay') || 0;
            var fullscreenAllowed = videoHolder.data('fs') || 0;
            var releventVideos = videoHolder.data('rel') || 0;
            var loop = videoHolder.data('loop') || 0;

            self.array_videos.push([domId, youtubeId, {
                height: '390',
                width: '640',
                showinfo: 0,
                rel: releventVideos || 0,
                fs: fullscreenAllowed || 0,

                // Afficher les controles de la video en option (data attribute)
                controls: showControles || 0,

                // AutoPlay en option (data attribute), il faut ajouter mute: 1 car navigateur ne permet plus de lancer des videos avec son.
                autoplay: autoplay || 0,
                mute: autoplay || 0,

                // Permettre de lire la video indéfiniment en option (data attribute)
                loop: loop || 0,

                enablejsapi: 1
            }, false ]);

            if (autoplay == 1) {
                self.play_video($("#" + videoHolder.attr('id')).closest(self.selectors.PARENT), youtubeId);
            }
        });
    }

    self.initPlayer = function (domId, videoId, options, isActive, index) {
        if (isActive) return;

        var settings = {
            videoId: videoId,
            events: {
                'onReady': function (event) {
                  self.onPlayerReady(event, index);
                },
                'onStateChange': self.onPlayerStateChange
            }
        };

        settings.playerVars = options;
        var player = new YT.Player(domId, settings);

        var updatedSetting = options || {};
        updatedSetting.player = player;
        self.players[domId] = options || {};

        var videoHolder = $(this);
        videoHolder.data(self.data_selectors.INITIATED, true);
    }

    self.onPlayerReady = function (event, index) {
        var player = event.target;
        var vidDomId = event.target.l.id;
        var playerSettings = self.players[vidDomId];

        if (vidDomId != self.lastVideoPlay && self.lastVideoPlay != null) {
            self.players[self.lastVideoPlay].player.pauseVideo();
        }

        // Mark the current video as active and all the others as inactive.
        for (var i=0; i < self.array_videos.length; i++) {
          var status = false;
          if (i == index) status = true;
          self.array_videos[i][3] = status;
        }

        self.lastVideoPlay = vidDomId;
        player.playVideo();
    }

    self.onPlayerStateChange = function (event) {
        var player = event.target;
        var parent = event.target.f.parentElement;
        var playerId = event.target.l.id;
        var playerSettings = self.players[playerId];

        if (event.data == YT.PlayerState.ENDED) {
            parent.setAttribute('activity-status', 'ended');
        } else if (event.data == YT.PlayerState.PLAYING) {
            parent.setAttribute('activity-status', 'playing');
        } else if (event.data == YT.PlayerState.PAUSED) {
            parent.setAttribute('activity-status', 'paused');
        } else if (event.data == YT.PlayerState.BUFFERING) {
            parent.setAttribute('activity-status', 'buffering');
        } else if (event.data == YT.PlayerState.CUED) {
            parent.setAttribute('activity-status', 'cued');
        } else if (event.data == YT.PlayerState.UNSTARTED) {
            player.playVideo();
        }
    }

    return youtube_videos;
}

var youtubeController = new theme.Youtube_videos();

/**************************
  Slider logo only mobile
***************************/

theme.onlyMobileSlider = new function() {

  function onlyMobileSlider() {

    var settings = {
      selector: '[data-slider-only-mobile]'
    };

    $(settings.selector).each(function() {
      var $carousel = $(this).flickity();
      $carousel.flickity('destroy');
      $carousel.addClass('slider__destroyed');
    });
  }
  return onlyMobileSlider;
}

var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
    isMobile = true;
}

if ($(window).width() < 640) {
    isMobile = true;
}

if (!isMobile) {
  var onlyMobileSlider = new theme.onlyMobileSlider();
}

/**************************
  Slider
***************************/

theme.slickCustom = new function() {

  function slickCustom() {

    // init default settings
    var settings = {
      selector: '[data-f]',
      selectorData : 'f'
    };

    // init slick default settings
    var slickSettings = {

    };

    // iterate across all slider
    $(settings.selector).each(function() {

      var $currentEl = $(this);
      // get elements settings
      var elementSettings = $currentEl.data(settings.selectorData);
      // merge default settings with elements settings
      var finalSettings = $.extend({}, slickSettings, elementSettings);

      // wait all images in slider are loaded
      $currentEl.imagesLoaded( function() {
        // init carousel
        var $carousel = $currentEl.slick(finalSettings);
      });

    });
  }
  return slickCustom;
}

var slickCustom = new theme.slickCustom();
